import { z } from "zod/v4"

export const RelationSchema = z.object({
  id: z.number().default(0),
  name: z.string().default(""),
})
export type Relation = z.infer<typeof RelationSchema>
export const RelationEmpty = RelationSchema.parse({})

export const RelationDataSchema = z.object({
  id: z.string().default(""),
  name: z.string().default(""),
  order: z.number().default(0),
})
export type RelationData = z.infer<typeof RelationDataSchema>
export const RelationDataEmpty = RelationDataSchema.parse({})
